var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@mui/material';
function AlertWarningIconInner(props) {
  return /*#__PURE__*/React.createElement("svg", __assign({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.345 4.12108L21.5315 16.8912C22.7198 19.0029 21.5548 21 19.1337 21L4.87684 21C2.45348 21 1.2879 19.0073 2.4773 16.8916L9.65636 4.12147C10.8521 1.99444 13.1468 1.99193 14.345 4.12108ZM12.602 5.10195C12.1692 4.33284 11.735 4.48227 11.3998 5.10156L4.22069 17.8717C3.87977 18.5411 3.98299 19 4.87684 19H19.1337C19.7885 19 20.2272 18.6515 19.7885 17.8721L12.602 5.10195ZM12.0002 18C11.4479 18 11.0002 17.5523 11.0002 17C11.0002 16.4477 11.4479 16 12.0002 16C12.5525 16 13.0002 16.4477 13.0002 17C13.0002 17.5523 12.5525 18 12.0002 18ZM11.0002 9.00293C11.0002 8.44903 11.4441 8 12.0002 8C12.5525 8 13.0002 8.44853 13.0002 9.00293V13.9971C13.0002 14.551 12.5563 15 12.0002 15C11.4479 15 11.0002 14.5515 11.0002 13.9971V9.00293Z",
    fill: ""
  }));
}
export var AlertWarningIcon = function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, __assign({
    inheritViewBox: true,
    component: AlertWarningIconInner
  }, props));
};